import { IssueReporter } from "utils/issueReporter";

// Sentry alerts page on `level: error`: 5xx is a backend fault, anything
// else (4xx, client-side 408 timeouts, statusless fetch failures) is noise.
export const reporterForStatus = (status: unknown) =>
  typeof status === "number" && status >= 500
    ? IssueReporter.error
    : IssueReporter.warning;
